import axios, { AxiosResponse } from 'axios';
import { TimeSlotDataPayload } from '../Components/Pages/RSAMeetingScheduler/RSAMeetingScheduler';
import moment from 'moment';

export async function getSpecialistMeetingList(payload: any, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            totalRecords: 5,
            dataTableData: [
                {
                    date: new Date().toISOString(),
                    data: [
                        {
                            EmployerSpotlightPresentationId: 1,
                            OrganizationName: 'OrganizationName 1',
                            PresentationTopic: 'Hilton Presentation 1',
                            PresentationDate: new Date().toDateString(),
                            StartTime: '10:00AM',
                            EndTime: '11:00AM',
                            PresentationModeCode: 'OL',
                            Location: 'some good place to have a presentation',
                            Notes: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.'
                        },
                        {
                            EmployerSpotlightPresentationId: 2,
                            OrganizationName: 'OrganizationName 2',
                            PresentationTopic: 'Hilton Presentation 2',
                            PresentationDate: new Date().toDateString(),
                            StartTime: '11:30AM',
                            EndTime: '11:45AM',
                            PresentationModeCode: 'OL',
                            Location: 'some good place to have a presentation',
                            Notes: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.'
                        },
                        {
                            EmployerSpotlightPresentationId: 3,
                            OrganizationName: 'OrganizationName 3',
                            PresentationTopic: 'Hilton Presentation 3',
                            PresentationDate: new Date().toDateString(),
                            StartTime: '2:30PM',
                            EndTime: '2:55PM',
                            PresentationModeCode: 'OL',
                            Location: 'some good place to have a presentation',
                            Notes: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.'
                        },
                    ]
                }
            ],
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/EmployerSpotlightPresentation/SearchESP`, payload);
        return result;
    }
}

export async function searchSpecialistMeetingRequestList(payload: any, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            totalRecords: 5,
            dataTableData: [
                {
                    date: new Date().toISOString(),
                    data: [
                        {
                            something: 'test'
                        }
                    ]
                }
            ],
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/EmployeeSpecialistMeeting/SearchEmploymentSpecialistMeetingRequest`, payload);
        return result;
    }
}

export async function getSpecialistMeetingById(ESPId: number, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            EmployerSpotlightPresentationId: 1,
            OrganizationName: 'OrganizationName 1',
            PresentationTopic: 'Hilton Presentation 1',
            PresentationDate: new Date().toDateString(),
            StartTime: '10:00AM',
            EndTime: '11:00AM',
            PresentationModeCode: 'OL',
            Location: 'some good place to have a presentation',
            Notes: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.'
        },
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/EmployerSpotlightPresentation/getESPById`);
        return result;
    }
}

export async function getSpecialistMeetingMaster(mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: [
            {
                EmploymentHelpTopicId: 1,
                DisplayName: 'Information on local degree and certificate programs',
                AskMoreInfo: false,
                MoreInfoText: null
            },
            {
                EmploymentHelpTopicId: 2,
                DisplayName: 'Resumes and cover letters',
                AskMoreInfo: false,
                MoreInfoText: null
            },
            {
                EmploymentHelpTopicId: 3,
                DisplayName: 'Searching and applying for jobs',
                AskMoreInfo: false,
                MoreInfoText: null
            },
            {
                EmploymentHelpTopicId: 4,
                DisplayName: 'Interview preparation and mock interviews',
                AskMoreInfo: false,
                MoreInfoText: null
            },
            {
                EmploymentHelpTopicId: 5,
                DisplayName: 'Other Assistance',
                AskMoreInfo: true,
                MoreInfoText: 'other assistance requested'
            },
        ],
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Master/GetHelpTopics`);
        return result;
    }
}

export async function getSpecialistMeetingListAssignedToMaster(mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: [
            {
                id: 1,
                displayName: 'Dummy data - API pending',
            },
            {
                id: 2,
                displayName: 'Dummy data - API pending',
            },
            {
                id: 3,
                displayName: 'Dummy data - API pending',
            },
            {
                id: 4,
                displayName: 'Dummy data - API pending',
            },
            
        ],
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        // after the change that we decided that employmentCoorinator role is the one who actually been assigned to meet the client.
        let result = await axios.get(`/EmployeeSpecialistMeeting/GetEmploymentCoordinators`);
        return result;
    }
}

export async function getSpecialistMeetingRequestCoordinators(mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: [
            {
                id: 1,
                displayName: 'Dummy data - API pending',
            },
            {
                id: 2,
                displayName: 'Dummy data - API pending',
            },
            {
                id: 3,
                displayName: 'Dummy data - API pending',
            },
            {
                id: 4,
                displayName: 'Dummy data - API pending',
            },
            
        ],
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/EmployeeSpecialistMeeting/GetEmploymentCoordinators`);
        return result;
    }
}
export async function getCounselorsList(mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: [
            {
                id: 1,
                displayName: 'Dummy data - API pending',
            },
        ],
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/EmployeeSpecialistMeeting/GetCounselors`);
        return result;
    }
}

export async function postMeetingRequest(payload: any, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            isSuccess: true,
            failReason: '',
        },
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/EmployeeSpecialistMeeting/SaveEmploymentSpecialistMeetingRequest`, payload);
        return result;
    }
}

export async function getSpecialistMeetingRequestById(MRId: string, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            employmentSpecialistMeetingRequestId: '',
            requestedBy: '',
            preferredDateTime: '',
            comments: '',
            requestedDate: '',
            helpTopics: ['topic1','topic2']
        },
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/EmployeeSpecialistMeeting/GetEmploymentSpecialistMeetingRequest/${MRId}`);
        return result;
    }
}

export async function saveRSAStaffSchedule(payload: any, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            employmentSpecialistMeetingRequestId: '',
            requestedBy: '',
            preferredDateTime: '',
            comments: '',
            requestedDate: '',
            helpTopics: ['topic1','topic2']
        },
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/EmployeeSpecialistMeeting/SaveRSAStaffSchedule`,payload);
        return result;
    }
}

export async function getTimeSlotData(payload: TimeSlotDataPayload, mockMode = true) {
    const startOfMonth = moment(payload.selectedDate).startOf('month');
    const endOfMonth = moment(payload.selectedDate).endOf('month');
    let currDay = moment(payload.selectedDate).startOf('month');
    //let monthArray: string[] = [];
    let testData:any[] = [];
    while(currDay.isSameOrBefore(endOfMonth,'day')){
        let tempDay = moment(currDay.format()).startOf('day');
        //monthArray.push(tempDay.format());
        let startTime = tempDay.add(9,'hour').format();
        let meetingCount = getRandomInt(4);
        for(let i=0;i<meetingCount;i++){
            let currMeeting = {
                meetingDate: tempDay.startOf('day').format(),
                startTime: startTime,
                endTime: moment(startTime).add(1, 'hour').format(),
                requestedBy: `Test Requester${getRandomInt(10)}`
            };
            testData.push(currMeeting);
            startTime = moment(startTime).add(1,'hour').format();
        }
        currDay = currDay.add(1, 'day');
    }
    const dummyResponse = {
        status: 200,
        data: testData,
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/EmployeeSpecialistMeeting/GetRSAStaffScheduleInfo`,payload);
        return result;
    }
}

function getRandomInt(max:number) {
    return Math.floor(Math.random() * max);
  }